module.exports = __webpack_public_path__ + "img/ab-page4-cd.d2990f73.png";